import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

export interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
  localize?: boolean;
}

export const LocalizedLink: React.FC<LocalizedLinkProps> = ({
  to,
  localize = true,
  ...props
}) => {
  const { getLocalizedPath } = useTranslation();
  // const navigate = useNavigate();
  
  // Only localize the path if requested
  const localizedTo = localize ? getLocalizedPath(to) : to;
  
  // Use React Router's Link for admin routes to maintain client-side navigation
  if (localizedTo.startsWith('/admin')) {
    return <Link to={localizedTo} {...props} />;
  }
  
  // Return a regular anchor tag with href for real navigation for non-admin routes
  return (
    <a 
      href={localizedTo} 
      {...props} 
      onClick={(e) => {
        // If the user is holding down a modifier key (ctrl, shift, etc.), let the browser handle it
        // if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        //   return;
        // }
        
        // // Otherwise prevent default and handle with React Router
        // e.preventDefault();
        
        // // If there's an onClick handler in props, call it
        if (props.onClick) {
          props.onClick(e);
        }
        
        // // Use React Router's navigation API
        // navigate(localizedTo);
      }}
    />
  );
}; 